import styled from "styled-components";
import { Input } from "antd";

export const Wrapper = styled(Input)`
  width: 100%;
  padding: 8px 15px;
  font-size: 20px;
  border-radius: 3px;
  border: 2px solid transparent;
  outline: 1px solid transparent;
  background-color: white; /* Set background color to white */
  ::placeholder {
    color: #2c3e50;
    font-size: 20px;
  }
  :hover {
    border: 2px solid black;
    outline: 1px solid #fff;
  }
`;
